export const blue = {
  backgroundColor: 'rgba(41,139,255, 0.3)',
  color: 'rgba(0,0,0, 0.8)',
}

export const gray = {
  backgroundColor: 'rgba(204,204,221, 0.3)',
  color: 'rgba(0,0,0, 0.8)',
}

export const orange = {
  backgroundColor: 'rgba(238,169,0, 0.3)',
  color: 'rgba(0,0,0, 0.8)',
}

export const red = {
  backgroundColor: 'rgba(255,102,102, 0.3)',
  color: 'rgba(0,0,0, 0.8)',
}

export const green = {
  backgroundColor: 'rgba(2,187,79, 0.3)',
  color: 'rgba(0,0,0, 0.8)',
}

export const yellow = {
  backgroundColor: 'rgba(255,196,0, 0.3)',
  color: 'rgba(0,0,0, 0.8)',
}

export const purple = {
  backgroundColor: 'rgba(149,117,205, 0.3)',
  color: 'rgba(0,0,0, 0.8)',
}

export const teal = {
  backgroundColor: 'rgba(0,191,165, 0.3)',
  color: 'rgba(0,0,0, 0.8)',
}
